export default __webpack_public_path__ + "static/media/work-background.d0792142.png";